import useDashboardUrlCondition from 'components/Dashboard/Navigation/useDashboardUrlCondition';
import useNavSections from 'components/Dashboard/Navigation/useNavSections';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import DropdownComponent from 'components/Settings/WebsiteFeeds/DropdownComponent';
import React, { useContext, useEffect, useRef, useState } from 'react';
import LocalStorage from 'utils/LocalStorage';
import { store } from 'components/Store';

function DefaultPageSelector() {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const { defaultUrl } = state;
  const [selectedDefaultUrl, setSelectedDefaultUrl] = useState(defaultUrl ?? LocalStorage.getItem('defaultUrl'));

  const linksContainerRef = useRef(null);
  const navPagesRef = useRef(null);
  const actionsElementRef = useRef(null);

  const { linksToRender } = useNavSections({
    linksContainerRef,
    navPagesRef,
    actionsElementRef,
    onItemClick: () => {},
    onShowAnalyticsPopup: () => {},
    onShowReportsPopup: () => {},
  });

  const { allowedDashboardUsers } = useDashboardUrlCondition();

  useEffect(() => {
    //OP: Reset the default url if it is not in the links to render
    const currentDefaultUrl = linksToRender.find((link) => link.pathname === selectedDefaultUrl);
    const fallbackDefaultUrl = allowedDashboardUsers ? 'dashboard' : 'monitor-inbox';
    if (!selectedDefaultUrl || !currentDefaultUrl) {
      setSelectedDefaultUrl(fallbackDefaultUrl);
      LocalStorage.setItem('defaultUrl', fallbackDefaultUrl);
      dispatch({ type: 'MODIFY_SECTION', parameter: 'defaultUrl', value: fallbackDefaultUrl });
    }
  }, [linksToRender, selectedDefaultUrl, allowedDashboardUsers, dispatch]);

  const mainItem = linksToRender?.find((link) => link.pathname === selectedDefaultUrl)?.label || 'Dashboard';

  return (
    <div className='settings-button setting-item w-100 d-flex pb-0'>
      <span className='icon-container-pin paragraph-p1'>
        <span className='icon-pin-bold specific-right-margin-15' />
      </span>
      <div className='specific-bottom-padding-1'>
        <span>My default page</span>
        <DropdownComponent
          mainItem={() => <span className='hidden-lines hidden-one-line nowrap-item pr-3'>{mainItem}</span>}
          mainItemClass='default-page-button text-main-blue-70'
          dropdownClass='default-page-dropdown'
          fixedDropdown={true}
          fixedTopSpace={-32}
          openToRight={true}
        >
          <ul className='policy-list p-0 m-0'>
            {linksToRender
              ?.filter((link) => !link.disabled)
              ?.map((link) => {
                return (
                  <li key={link.id}>
                    <button
                      className={`w-100 d-block text-left general-button list-action-button pl-3 specific-right-padding-40 py-2 reset-link reset-link-color text-main-blue nowrap-item position-relative`}
                      onClick={(e) => {
                        LocalStorage.setItem('defaultUrl', link.pathname);
                        dispatch({ type: 'MODIFY_SECTION', parameter: 'defaultUrl', value: link.pathname });
                        setSelectedDefaultUrl(link.pathname);
                        createNotification('success', 'Your default page has been changed for this device');
                      }}
                    >
                      {link.label}
                      {link.pathname === selectedDefaultUrl && (
                        <span className='icon-tick position-absolute top-10 right-11' />
                      )}
                    </button>
                  </li>
                );
              })}
          </ul>
        </DropdownComponent>
      </div>
    </div>
  );
}

export default DefaultPageSelector;
